import { isDicomView } from '@/modules/Editor/utils/radiology/isDicomView'

export const isReformattedDICOMView = (view: { type: string }): boolean =>
  isDicomView(view) && !view.isPrimary
